/**
 * OrbDocTutorialsAdvancedAiGenerationSLOrbDocTutorialsAdvancedAiGenerationSLPage
 *
 * Page component for OrbDocTutorialsAdvancedAiGenerationSLOrbDocTutorialsAdvancedAiGenerationSLPage
 * Path: /sl/docs/tutorials/advanced/ai-generation
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsAdvancedAiGenerationSLDocScreenView as __OrbDocTutorialsAdvancedAiGenerationSLDocScreenView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationSLDocScreenView';
import { OrbDocTutorialsAdvancedAiGenerationSLDocAnalyticsView as __OrbDocTutorialsAdvancedAiGenerationSLDocAnalyticsView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsAdvancedAiGenerationSLOrbDocTutorialsAdvancedAiGenerationSLPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsAdvancedAiGenerationSLOrbDocTutorialsAdvancedAiGenerationSLPage(_props: OrbDocTutorialsAdvancedAiGenerationSLOrbDocTutorialsAdvancedAiGenerationSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Ustvarjanje programov z umetno inteligenco","description":"Aplikacijo opiši z besedami in naj agent orb napiše program, prevajalnik pa preveri vsak korak.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/advanced/ai-generation"},{"locale":"ar","path":"/ar/docs/tutorials/advanced/ai-generation"},{"locale":"sl","path":"/sl/docs/tutorials/advanced/ai-generation"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsAdvancedAiGenerationSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsAdvancedAiGenerationSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsAdvancedAiGenerationSLOrbDocTutorialsAdvancedAiGenerationSLPage;
